export default __webpack_public_path__ + "static/media/sip2.aaa91ed8.jpg";